<template>
	<div class="architecture">
		<h1>建筑行业亟需数字化升级</h1>
		<div class="architecture-box">
			<div
				class="item"
				v-for="item in dataList"
				:key="item.id"
			>
				<div class="icon">
					<img
						:src="item.icon"
						class="item-img"
					/>
				</div>
				<h6 class="title">{{ item.title }}</h6>
				<p class="text">{{ item.text }}</p>
				<!-- hover线框流动效果 -->
				<span class="left border"></span>
				<span class="top border"></span>
				<span class="right border"></span>
				<span class="bottom border"></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DigitalUpgrade',
	components: {},
	props: {},
	data() {
		return {
			dataList: [
				{
					id: 0,
					title: '多层级管控不力',
					text: '存在集团、分公司、项目部等多个层级，经营目标、管理决策难以贯彻落实，经营和生产资源难以统筹。',
					icon: 'https://static.bimcc.com/openim/20220623074443_256638307124E4CEC077A308670FBC800890B7.png'
				},
				{
					id: 1,
					title: '计划与执行协同难',
					text: '工程项目总进度计划、月计划、周计划和生产执行以及质量、技术协同困难，项目难以优质高效完成。',
					icon: 'https://static.bimcc.com/openim/20220623074443_256638307124E4CEC077A308670FBC800890B7.png'
				},
				{
					id: 2,
					title: '经济与生产协同难',
					text: '经济线的销售、商务、招采和生产线的工程项目、质量、技术等协同困难，项目的目标难达成。',
					icon: 'https://static.bimcc.com/openim/20220623074443_256638307124E4CEC077A308670FBC800890B7.png'
				},
				{
					id: 3,
					title: '生产与现场协同难',
					text: '生产与现场人员管理、智慧工地等不在一个系统内管理，数据和流程没有打通，无法实时反馈项目现场情况。',
					icon: 'https://static.bimcc.com/openim/20220623074443_256638307124E4CEC077A308670FBC800890B7.png'
				}
			]
		};
	},
	methods: {}
};
</script>

<style lang="less" scoped>
.architecture {
	width: 1200px;
	height: 100%;
	padding: 90px 0;
	box-sizing: border-box;
	h1 {
		color: #121933;
		font-size: 40px;
		font-family: 'albb65';
		line-height: 1.1;
		text-align: center;
		-webkit-animation-duration: 1s;
		animation-duration: 1s;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
		webkit-animation-name: h1;
		animation-name: h1;
	}
	@keyframes h1 {
		0% {
			opacity: 0;
			transform: translate(0px, 100px) scale3d(0.8, 0.8, 1);
		}
		100% {
			opacity: 1;
			transform: translate(0px, 0px);
		}
	}
	.architecture-box {
		display: flex;
		justify-content: space-between;
		position: relative;
		padding: 100px 0;
		box-sizing: border-box;
		padding-bottom: 42px;
		box-sizing: border-box;
		.item {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: relative;
			width: 288px;
			height: 266px;
			padding: 10px 20px 0 20px;
			box-sizing: border-box;
			background: rgba(227, 236, 247, 0.54);
			text-align: center;
			.icon {
				position: absolute;
				width: 40%;
				top: -60px;
				left: 30%;
				z-index: 112;
				.item-img {
					width: 100%;
				}
			}
			.title {
				padding-bottom: 42px;
				box-sizing: border-box;
				color: #3d3d3d;
				font-family: 'Source Han Sans CN';
				font-style: normal;
				font-weight: 500;
				font-size: 24px;
				font-weight: bold;
				line-height: 27px;
				z-index: 112;
			}
			.text {
				color: #3d3d3d;
				font-family: 'Source Han Sans CN';
				font-style: normal;
				font-weight: 400;
				font-size: 16px;
				line-height: 24px;
				text-align: left;
				z-index: 112;
			}
		}
		.item::after,
		.item::before,
		.item span {
			position: absolute;
			left: 0px;
			top: 0;
			bottom: 0;
			right: 0;
		}
		.item span {
			line-height: 200px;
			text-align: center;
		}
		.item:hover::after,
		.item:hover::before {
			content: '';
			box-shadow: inset 0 0 0 2px #337eff;
			animation: clipAnimate 10s linear infinite;
			z-index: 11;
		}
		.item:hover::before {
			animation-delay: -5s;
		}
		@keyframes clipAnimate {
			0% {
				clip: rect(0, 288px, 2px, 0);
			}
			25% {
				clip: rect(0, 2px, 266px, 0);
			}
			50% {
				clip: rect(198px, 288px, 266px, 0);
			}
			75% {
				clip: rect(0, 288px, 266px, 284px);
			}
			100% {
				clip: rect(0, 288px, 2px, 0);
			}
		}
	}
}
</style>
